import { render, staticRenderFns } from "./FormatListSelector.vue?vue&type=template&id=0703bf2c&"
import script from "./FormatListSelector.vue?vue&type=script&lang=ts&"
export * from "./FormatListSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports